import React, { useEffect, useState } from "react";
import './AutoComplete.css'

const AutoComplete = (props) => {
  const { placeholder, options, onTab, inputRef, id, indexId, key, text, onBlur = () => { }, isError, onKeyDown = () => {}, className = '', disabled = false } = props;

  const [inputValue, setInputValue] = useState('');
  const [suggestedValue, setSuggestedValue] = useState('');
  options.sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    if (props.text || props.text == '') {
      setInputValue(props.text)
    } else {
      setInputValue('')
    }
  }, [props])

  // const handleChange = (e) => {
  //   const value = e.target.value;
  //   setInputValue(value);
  //   const match = options.find(item => item.label.startsWith(value))?.label;

  //   if (match && value) {
  //     const remaining = match.slice(value.length);
  //     setSuggestedValue(remaining);
  //   } else {
  //     setSuggestedValue('');
  //   }
  // };

  const calculateMatchPercentage = (input, option) => {
    if (option.startsWith(input)) {
      return (input.length / option.length) * 100;
    }
    return 0;
  };

  const handleChange = (e) => {
    const value = e.target.value?.toUpperCase();
    setInputValue(value);
    
    if (value) {
      let bestMatch = '';
      let highestPercentage = 0;

      options.forEach(item => {
        let label = item.label?.toUpperCase()
        const matchPercentage = calculateMatchPercentage(value, label);
        
        if (matchPercentage > highestPercentage) {
          bestMatch = item.label;
          highestPercentage = matchPercentage;
        }
      });

      if (bestMatch) {
        const remaining = bestMatch.slice(value.length);
        setSuggestedValue(remaining);
      } else {
        setSuggestedValue('');
      }
    } else {
      setSuggestedValue('');
    }
  };

  const handleKeyDown = (e) => {
    if(onKeyDown){
      onKeyDown(e);
    }
    if (e.key === 'Backspace') {
      setSuggestedValue('');
    }
    if (e.key === 'Tab') {
      let exactMatch = options.find(item => item.label === inputValue);
      let value = exactMatch ? exactMatch.label : inputValue + suggestedValue;
      setSuggestedValue('');
      onTab(value, e);
    }
  };

  const handleBlur = (e) => {
    onBlur(e);
    setSuggestedValue('')
  }

  return (
    <div className="autocomplete-wrapper">
      <div className="input-wrapper">
        <input
          id={id}
          indexId={indexId}
          key={key}
          ref={inputRef}
          type="text"
          autoComplete="off"
          className={`autocomplete-input ${className} ${isError ? 'invalid' : ""}`}
          placeholder={placeholder || "Enter Text"}
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          disabled={disabled}
        />
        <div className="suggestion">
          {inputValue}
          <span className="suggested-text">{suggestedValue}</span>
        </div>
      </div>
    </div>
  )
}

export default AutoComplete
